// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-info {\n    display: flex;\n    align-items: center;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.login-info-icon {\n    margin-right: 20px;\n}\n\n.footer-login {\n    margin: 10px auto;\n    text-align: center; /* Edge */\n    width: fit-content;\n}\n\n.bounded-tile {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n", ""]);
// Exports
module.exports = exports;
